type HotelSearchURLParams = {
  adults?: number;
  childAges?: number[];
  checkinDate: string;
  checkoutDate: string;
  currency?: string;
  entityId: string;
  hotelStars?: number;
  locale?: string;
  market?: string;
  rooms?: number;
  source?: string;
  impressionId?: string;
};

export const buildHotelsSearchURL = (params: HotelSearchURLParams) => {
  const searchParams = new URLSearchParams();

  searchParams.append('checkin', params.checkinDate);
  searchParams.append('checkout', params.checkoutDate);
  searchParams.append('entity_id', params.entityId);

  if (params.currency) {
    searchParams.append('currency', params.currency);
  }

  if (params.locale) {
    searchParams.append('locale', params.locale);
  }

  if (params.market) {
    searchParams.append('market', params.market);
  }

  if (params.adults) {
    searchParams.append('adults', String(params.adults));
  }

  if (params.childAges && params.childAges.length > 0) {
    searchParams.append('children_ages', params.childAges.join(','));
  }

  if (params.impressionId) {
    searchParams.append('impression_id', params.impressionId);
  }

  if (params.rooms) {
    searchParams.append('rooms', String(params.rooms));
  }

  if (params.source) {
    searchParams.append('source', params.source);
  }

  if (params.hotelStars != null) {
    searchParams.append(
      'filters',
      JSON.stringify({ starsRatingFilter: String(params.hotelStars) }),
    );
  }

  return `/hotels/search?${searchParams.toString()}`;
};
